module.exports = __webpack_public_path__ + "c5cdf33d040cd0d857880344bf2eb84f.jpg";